import React from "react";
import { motion } from "framer-motion";
import { InfoIcon } from "lucide-react";
import { HandArrow } from "../brand/HandArrow";
import { CourtLines } from "../brand/CourtLines";
import { YearTrack } from "./YearTrack";
import { phases } from "../../data/content";
export function RouteSection() {
  return <section aria-labelledby="route-title" className="relative overflow-hidden border-y border-white/10 bg-navy-800" data-id="element-176" data-mp="3gz5d48zoi0hm">
      <CourtLines className="pointer-events-none absolute -bottom-64 -left-48 h-[640px] w-[640px] text-cyan/[0.06]" data-id="element-177" data-mp="3lwoqz7sgsb91" />
      <div className="container-x relative py-14 sm:py-20 lg:py-28" data-id="element-178" data-mp="3qye3ysz8yyzr">
        <div className="grid items-end gap-6 lg:grid-cols-12" data-id="element-179" data-mp="3uz6dlnc175wk">
          <div className="lg:col-span-7" data-id="element-180" data-mp="3rbp9gmy6tty">
            <p className="eyebrow" data-id="element-181" data-mp="3r1yhqu2win7">A clear route through the unit</p>
            <h2 id="route-title" className="section-title mt-4" data-id="element-182" data-mp="20knb3krhp2ej">
              From first skills. <span className="text-cyan" data-id="element-183" data-mp="25ior1wtmclls">To small-sided play.</span>
            </h2>
          </div>
          <p className="max-w-[30rem] text-[16px] leading-[1.7] text-ice/80 sm:text-[17px] lg:col-span-5" data-id="element-184" data-mp="2l6duahcsv2et">
            Twelve lessons build from first routines and stick control toward teamwork, decision-making and modified games.
          </p>
        </div>

        <YearTrack data-id="element-185" data-mp="2cek74c2rmtg9" />

        <ol className="mt-12 grid gap-6 sm:mt-14 lg:mt-20 lg:grid-cols-3 lg:gap-0" data-id="element-186" data-mp="27f7ltvrjlufs">
          {phases.map((phase, i) => <motion.li key={phase.number} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-80px"
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: i * 0.06
        }} className="relative border-b border-white/10 pb-8 last:border-b-0 lg:border-b-0 lg:pb-0 lg:pr-10" data-id="element-187" data-mp="346032wq7psj5" data-mpi={i}>
              <div className="flex items-end gap-4 lg:items-center" data-id="element-188" data-mp="1jqg09n8gkabz">
                <span aria-hidden="true" className="font-display text-[64px] font-extrabold leading-[0.82] text-transparent sm:text-[112px] lg:text-[148px]" style={{
              WebkitTextStroke: "2px #2CC4E8"
            }} data-id="element-189" data-mp="1eq0p92bnfex6">
                  {phase.number}
                </span>
                <h3 className="font-display text-[26px] font-bold uppercase leading-[0.95] text-ice lg:hidden" data-id="element-190" data-mp="17698phexzhlf">
                  <span className="sr-only" data-id="element-191" data-mp="1c4kk3wkvy05r">Phase {i + 1}: </span>
                  {phase.title}
                </h3>
                <span className="hidden h-px flex-1 bg-white/15 lg:block" aria-hidden="true" data-id="element-192" data-mp="xf4wuqkkccut" />
                {i < phases.length - 1 && <HandArrow className="hidden h-8 w-16 shrink-0 text-orange lg:block" data-id="element-193" data-mp="ogjiz8q1dm0d" />}
              </div>
              <h3 className="mt-6 hidden font-display text-[34px] font-bold uppercase leading-none text-ice lg:block" data-id="element-194" data-mp="shv87d500581">
                <span className="sr-only" data-id="element-195" data-mp="ei3oqwvppwmn">Phase {i + 1}: </span>
                {phase.title}
              </h3>
              <p className="mt-4 max-w-[22rem] text-[15px] leading-relaxed text-ice/75 sm:text-base lg:mt-3" data-id="element-196" data-mp="jgf0jd5kih7i">{phase.summary}</p>
              <ul className="mt-5 flex flex-wrap gap-2 lg:mt-6 lg:block lg:max-w-[22rem] lg:border-t lg:border-white/15" data-id="element-197" data-mp="3w1atjdsobeq4">
                {phase.focus.map(item => <li key={item} className="flex items-center gap-2 rounded-[6px] border border-white/10 bg-navy px-3 py-2 text-[13px] font-semibold text-ice/90 lg:gap-3 lg:rounded-none lg:border-0 lg:border-b lg:bg-transparent lg:px-0 lg:py-3 lg:text-[15px]" data-id="element-198" data-mp="9uvx9j46q9fe">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-orange" aria-hidden="true" data-id="element-199" data-mp="dv5yyjky2dog" />
                    {item}
                  </li>)}
              </ul>
            </motion.li>)}
        </ol>

        <p className="mt-10 flex max-w-[44rem] items-start gap-2.5 text-[13px] leading-relaxed text-ice/65 sm:mt-14 sm:text-sm" data-id="element-200" data-mp="11l0e57sqkebv">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-201" data-mp="xk83qb84o3e0" />
          Start with routines and control, then build toward modified games. Adapt space, equipment and pacing to your learners.
        </p>
      </div>
    </section>;
}